export const notNullish = <T>(x: T): x is NonNullable<T> =>
  x !== null && x !== undefined;

export const jsonParseSafe = (text: string) => {
  try {
    return JSON.parse(text);
  } catch (err) {
    return;
  }
};
